// Root, not a reload: reloading a protected path seeds a redirectUrl via
// the UNAUTHORIZED bounce, which then suppresses the next signup's onboarding.
export const goToRoot = () => {
  // oxlint-disable-next-line no-restricted-properties
  window.location.replace('/');
};
